import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { useUpdateRegionalCalendar } from 'features/regionalCalendar/update';

import { CalendarDTO } from 'entities/calendar';
import styles from './EditRegionalCalendarButton.module.scss';

const EditRegionalCalendarButton: React.FC<{ calendar: CalendarDTO }> = ({ calendar }) => {
  const { t } = useTranslation('Calendar');

  const openEditModal = useUpdateRegionalCalendar(calendar);
  return (
    <Button type="link" className={styles.editBtn} onClick={openEditModal}>
      {t('Shared:editBtn.text')}
    </Button>
  );
};

export { EditRegionalCalendarButton };
